import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-white via-light-cyan/30 to-white pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2e89525a0496e69bf46b9bf15e1616c4.jpg"
          alt="Miami Pool Service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Wave Pattern Overlay */}
      <div className="absolute top-20 right-0 w-1/3 h-1/3 opacity-10 z-0">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="wave-hero" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <path d="M0 50 Q 25 30, 50 50 T 100 50" stroke="white" fill="none" strokeWidth="3" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#wave-hero)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center py-32">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight">
          Reliable Pool Service in Miami
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 font-light max-w-2xl mx-auto mb-10">
          Repairs, upgrades, and maintenance—done fast, clean, and professional.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <a
            href="tel:+17862738796"
            className="bg-tropical-teal text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-soft-aqua transition-all hover:scale-105 active:scale-95 flex items-center gap-3 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call Now
          </a>
          
          <Link
            to="/services"
            className="bg-white text-tropical-teal border-2 border-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-transparent hover:text-white transition-all hover:scale-105 active:scale-95 flex items-center gap-3 shadow-lg whitespace-nowrap cursor-pointer"
          >
            View Services
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

        {/* Trust Bullets */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-tropical-teal/20 rounded-full flex items-center justify-center mb-3">
              <i className="ri-calendar-check-line text-3xl text-white"></i>
            </div>
            <div className="text-white font-semibold text-lg">Fast Scheduling</div>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-tropical-teal/20 rounded-full flex items-center justify-center mb-3">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <div className="text-white font-semibold text-lg">Clean Work</div>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-tropical-teal/20 rounded-full flex items-center justify-center mb-3">
              <i className="ri-price-tag-3-line text-3xl text-white"></i>
            </div>
            <div className="text-white font-semibold text-lg">Clear Pricing</div>
          </div>
        </div>
      </div>

      {/* Decorative Palm Leaf */}
      <div className="absolute bottom-10 left-10 opacity-10 z-0 hidden lg:block">
        <i className="ri-plant-line text-white text-8xl"></i>
      </div>
    </section>
  );
}